(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-main"] && !Shopify.designMode) return;
  try {
    
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (event) {
      if (!(event.target instanceof Element)) return;

      const item = event.target.closest('.faq-main__item');

      if (item) {
        item.open = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tribe-bundles-carousel"] && !Shopify.designMode) return;
  try {
    

(() => {

  if (
    !('customElements' in window) ||
    customElements.get('tribe-bundles-carousel')
  ) return;


  class TribeBundlesCarousel extends HTMLElement {

    connectedCallback() {

      if (this._initialized) return;

      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('.tlcb__track');
      this.arrows = this.querySelector('[data-arrows]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');

      if (
        !this.viewport ||
        !this.track ||
        !this.arrows ||
        !this.prev ||
        !this.next
      ) return;


      this._initialized = true;

      this.onPrev = () => this.move(-1);
      this.onNext = () => this.move(1);


      this.onScroll = () => {

        if (this.frame) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });

      };


      this.onResize = () => this.update();


      this.prev.addEventListener(
        'click',
        this.onPrev
      );

      this.next.addEventListener(
        'click',
        this.onNext
      );

      this.viewport.addEventListener(
        'scroll',
        this.onScroll,
        { passive: true }
      );


      if ('ResizeObserver' in window) {

        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this.viewport);

      } else {

        window.addEventListener(
          'resize',
          this.onResize
        );

      }

      this.update();

    }



    disconnectedCallback() {

      if (!this._initialized) return;

      this.prev.removeEventListener(
        'click',
        this.onPrev
      );

      this.next.removeEventListener(
        'click',
        this.onNext
      );

      this.viewport.removeEventListener(
        'scroll',
        this.onScroll
      );

      window.removeEventListener(
        'resize',
        this.onResize
      );


      if (this.observer) {
        this.observer.disconnect();
      }

      if (this.frame) {
        cancelAnimationFrame(this.frame);
      }

      this.frame = null;
      this._initialized = false;

    }



    move(direction) {

      const card = this.track.querySelector('.tlcb__card');

      if (!card) return;


      const gap =
        parseFloat(
          getComputedStyle(this.track).columnGap
        ) || 0;


      const distance =
        card.getBoundingClientRect().width + gap;


      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;


      this.viewport.scrollBy({
        left: direction * distance,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });

    }



    update() {

      const maximum = Math.max(
        0,
        this.viewport.scrollWidth - this.viewport.clientWidth
      );


      this.arrows.hidden = maximum < 3;


      this.prev.disabled =
        this.viewport.scrollLeft <= 3;


      this.next.disabled =
        this.viewport.scrollLeft >= maximum - 3;


      this.viewport.tabIndex =
        maximum < 3 ? -1 : 0;

    }

  }


  customElements.define(
    'tribe-bundles-carousel',
    TribeBundlesCarousel
  );

})();


  } catch(e) { console.error(e); }
})();
})();
